import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../store/root-reducer';
// eslint-disable-next-line import/no-cycle
import BillingSubscription from './billing-subscription';
import {
  getAccountSubscriptionRequest,
  getPlansRequest,
  getInvoiceURLRequest,
  purchaseSubscriptionRequest,
  getConnectedUsersAndEmailAccountsRequest,
  applyCouponCodeRequest,
  getEmailVerificationCreditsRequest,
  getEmailVerificationPlanRequest,
  purchaseEmailVerificationCreditsRequest,
  modifySubscriptionRequest,
  purchaseModifySubscriptionRequest,
  purchaseLeadFinderModifySubscriptionRequest,
  reactivateSubscriptionRequest,
  reactivateLeadFinderSubscriptionRequest,
  resumeSubscriptionRequest,
  resumeLeadFinderSubscriptionRequest,
  handleSubscriptionRequest,
  handleLeadFinderChurnkeySubscriptionRequest,
  getLeadFinderSubscriptionRequest,
  getAccountSubscriptionPlanRequest,
  getPurchaseHistoryRequest,
  exportCreditHistoryRequest,
  getInboxAnalyzerSubscriptionRequest,
  handleInboxAnalyzerChurnkeySubscriptionRequest,
  modifyInboxAnalyzerSubscriptionRequest,
  getInboxAnalyzerSubscriptionPlanRequest,
  reactivateInboxAnalyzerSubscriptionRequest,
  resumeInboxAnalyzerSubscriptionRequest,
  getInboxAnalyzerInvoiceURLRequest,
  calculateAiCreditsPricingsRequest,
  aiCreditHistoryRequest,
  getCreditsTransactionStatusRequest,
} from './extra-actions';
import {
  resetSubscription,
  deleteAppliedCouponCode,
  resetPurchaseEmailVerificationCreditsResponse,
  resetModifySubscriptionResponse,
  resetReactivateSubscriptionResponse,
  resetReactivateLeadFinderSubscriptionResponse,
  resetResumeSubscriptionResponse,
  resetResumeLeadFinderSubscriptionResponse,
  resetHandleSubscriptionResponse,
  resetHandleLeadFinderSubscriptionChurnkeyResponse,
  resetInvoice,
  resetExportCreditHistoryRequest,
  resetPurchaseLeadFinderOneTimePlan,
  resetReactivateInboxAnalyzerSubscriptionResponse,
  resetResumeInboxAnalyzerSubscriptionResponse,
  resetInboxAnalyzerInvoice,
  resetHandleInboxAnalyzerSubscriptionChurnkeyResponse,
  resetAiCreditHistoryRequest,
  resetGetCreditsTransactionStatusRequest,
  resetPurchaseCreditsRequest,
} from './billing-subscription-slice';
import {
  getPostLoadMetaRequest,
  getUserSettingsRequest,
  getUserSubscriptionMetadataRequest,
} from '../../../home/extra-actions';
import {
  ApplyCouponCodeRequest,
  PurchaseEmailVerificationCreditsRequest,
  ModifySubscriptionRequest,
  PurchaseModifySubscriptionRequest,
  ReactivateResumeSubscriptionRequest,
  HandleSubscriptionRequest,
  PurchaseSubscriptionRequest,
} from './types';
import { ExportCreditHistoryPayload } from './types/purchase-history';
import { CalculateAiCreditsPricingsRequest } from './types/ai-credits';
import { CreditsTransactionStatusRequest } from './types/purchase-credits';

const mapStateToProps = (state: RootState) => ({
  sendGetAccountSubscriptionRequestStatus:
    state.billingAndSubscription.getAccountSubscriptionRequest.status,
  sendGetAccountSubscriptionPlanRequestStatus:
    state.billingAndSubscription.getAccountSubscriptionPlanRequest.status,
  sendGetAccountSubscriptionRequestError:
    state.billingAndSubscription.getAccountSubscriptionRequest.error,
  sendGetAccountSubscriptionPlanRequestError:
    state.billingAndSubscription.getAccountSubscriptionPlanRequest.error,
  sendGetPlansRequestStatus:
    state.billingAndSubscription.getPlansRequest.status,
  sendGetPlansRequestError: state.billingAndSubscription.getPlansRequest.error,
  sendGetInvoiceURLRequestStatus:
    state.billingAndSubscription.getInvoiceURLRequest.status,
  sendGetInvoiceURLRequestError:
    state.billingAndSubscription.getInvoiceURLRequest.error,
  sendGetInboxAnalyzerInvoiceURLRequestStatus:
    state.billingAndSubscription.getInboxAnalyzerInvoiceURLRequest.status,
  sendGetInboxAnalyzerInvoiceURLRequestError:
    state.billingAndSubscription.getInboxAnalyzerInvoiceURLRequest.error,
  sendPurchaseSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseSubscriptionRequest.status,
  sendPurchaseSubscriptionRequestError:
    state.billingAndSubscription.purchaseSubscriptionRequest.error,
  sendPurchaseSubscriptionRequestMessage:
    state.billingAndSubscription.purchaseSubscriptionRequest.message,
  sendGetAccountSubscriptionResponse:
    state.billingAndSubscription.getAccountSubscriptionResponse,
  sendGetAccountSubscriptionPlanResponse:
    state.billingAndSubscription.getAccountSubscriptionPlanResponse,
  sendGetLeadFinderSubscriptionResponse:
    state.billingAndSubscription.getLeadFinderSubscriptionResponse,
  sendGetInboxAnalyzerSubscriptionResponse:
    state.billingAndSubscription.getInboxAnalyzerSubscriptionResponse,
  sendGetConnectedUsersAndEmailAccountsRequestStatus:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest
      .status,
  sendGetConnectedUsersAndEmailAccountsRequestError:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest.error,
  sendGetConnectedUsersAndEmailAccountsRequestResponse:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsResponse,
  sendApplyCouponCodeRequestStatus:
    state.billingAndSubscription.applyCouponCodeRequest.status,
  sendApplyCouponCodeRequestMessage:
    state.billingAndSubscription.applyCouponCodeRequest.message,
  sendApplyCouponCodeRequestError:
    state.billingAndSubscription.applyCouponCodeRequest.error,
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetPlansResponse: state.billingAndSubscription.getPlansResponse,
  getInvoiceResponse: state.billingAndSubscription.getInvoiceResponse,
  getInboxAnalyzerInvoiceResponse:
    state.billingAndSubscription.getInboxAnalyzerInvoiceResponse,
  customerId: state.home.subscription?.customerId,
  leadFinderCustomerId: state.home.leadFinderSubscription?.customerId,
  inboxAnalyzerCustomerId: state.home.inboxAnalyzerSubscription?.customerId,
  subscriptionId: state.home.subscription?.subscriptionId,
  leadFinderSubscriptionId: state.home.leadFinderSubscription?.subscriptionId,
  inboxAnalyzerSubscriptionId:
    state.home.inboxAnalyzerSubscription?.subscriptionId,
  sendGetEmailVerificationCreditsRequestStatus:
    state.billingAndSubscription.getEmailVerificationCreditsRequest.status,
  sendGetEmailVerificationCreditsRequestError:
    state.billingAndSubscription.getEmailVerificationCreditsRequest.error,
  sendGetEmailVerificationPlansRequestStatus:
    state.billingAndSubscription.getEmailVerificationPlanRequest.status,
  sendGetEmailVerificationPlansRequestError:
    state.billingAndSubscription.getEmailVerificationPlanRequest.error,
  sendPurchaseEmailVerificationCreditsRequestStatus:
    state.billingAndSubscription.purchaseEmailVerificationCreditsRequest.status,
  sendPurchaseEmailVerificationCreditsRequestError:
    state.billingAndSubscription.purchaseEmailVerificationCreditsRequest.error,
  sendPurchaseEmailVerificationCreditsRequestMessage:
    state.billingAndSubscription.purchaseEmailVerificationCreditsRequest
      .message,
  getPurchaseEmailVerificationCreditsResponse:
    state.billingAndSubscription.purchaseEmailVerificationCreditsResponse,
  getEmailVerificationCreditsResponse:
    state.billingAndSubscription.getEmailVerificationCreditsResponse,
  getEmailVerificationPlanResponse:
    state.billingAndSubscription.getEmailVerificationPlanResponse,
  sendGetModifySubscriptionRequestStatus:
    state.billingAndSubscription.modifySubscriptionRequest.status,
  sendGetModifySubscriptionRequestError:
    state.billingAndSubscription.modifySubscriptionRequest.error,
  sendGetInboxAnalyzerModifySubscriptionRequestStatus:
    state.billingAndSubscription.modifyInboxAnalyzerSubscriptionRequest.status,
  sendGetInboxAnalyzerModifySubscriptionRequestError:
    state.billingAndSubscription.modifyInboxAnalyzerSubscriptionRequest.error,
  sendGetModifySubscriptionResponse:
    state.billingAndSubscription.modifySubscriptionResponse,
  sendGetPurchaseModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseModifySubscriptionRequest.status,
  sendPurchaseLeadFinderModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseLeadFinderModifySubscriptionRequest
      .status,
  sendGetReactivateSubscriptionRequestStatus:
    state.billingAndSubscription.reactivateSubscriptionRequest.status,
  sendGetReactivateSubscriptionRequestError:
    state.billingAndSubscription.reactivateSubscriptionRequest.error,
  sendGetReactivateLeadFinderSubscriptionStatus:
    state.billingAndSubscription.reactivateLeadFinderSubscriptionRequest.status,
  sendGetReactivateLeadFinderSubscriptionError:
    state.billingAndSubscription.reactivateLeadFinderSubscriptionRequest.error,
  sendGetReactivateInboxAnalyzerSubscriptionStatus:
    state.billingAndSubscription.reactivateInboxAnalyzerSubscriptionRequest
      .status,
  sendGetReactivateInboxAnalyzerSubscriptionError:
    state.billingAndSubscription.reactivateInboxAnalyzerSubscriptionRequest
      .error,
  sendGetReactivateSubscriptionResponse:
    state.billingAndSubscription.reactivateSubscriptionResponse,
  sendGetReactivateLeadFinderSubscriptionResponse:
    state.billingAndSubscription.reactivateLeadFinderSubscriptionResponse,
  sendGetReactivateInboxAnalyzerSubscriptionResponse:
    state.billingAndSubscription.reactivateInboxAnalyzerSubscriptionResponse,
  sendGetResumeSubscriptionRequestStatus:
    state.billingAndSubscription.resumeSubscriptionRequest.status,
  sendGetResumeSubscriptionRequestError:
    state.billingAndSubscription.resumeSubscriptionRequest.error,
  sendGetResumeLeadFinderSubscriptionStatus:
    state.billingAndSubscription.resumeLeadFinderSubscriptionRequest.status,
  sendGetResumeLeadFinderSubscriptionError:
    state.billingAndSubscription.resumeLeadFinderSubscriptionRequest.error,
  sendGetResumeInboxAnalyzerSubscriptionStatus:
    state.billingAndSubscription.resumeInboxAnalyzerSubscriptionRequest.status,
  sendGetResumeInboxAnalyzerSubscriptionError:
    state.billingAndSubscription.resumeInboxAnalyzerSubscriptionRequest.error,
  sendGetResumeSubscriptionResponse:
    state.billingAndSubscription.resumeSubscriptionResponse,
  sendGetResumeLeadFinderSubscriptionResponse:
    state.billingAndSubscription.resumeLeadFinderSubscriptionResponse,
  sendGetResumeInboxAnalyzerSubscriptionResponse:
    state.billingAndSubscription.resumeInboxAnalyzerSubscriptionResponse,
  sendGetHandleSubscriptionResponse:
    state.billingAndSubscription.handleSubscriptionResponse,
  sendGetHandleSubscriptionRequestError:
    state.billingAndSubscription.handleSubscriptionRequest.error,
  sendGetHandleSubscriptionRequestStatus:
    state.billingAndSubscription.handleSubscriptionRequest.status,
  sendGetHandleLeadFinderChurnkeySubscriptionError:
    state.billingAndSubscription.handleLeadFinderChurnkeySubscriptionRequest
      .error,
  sendGetHandleLeadFinderChurnkeySubscriptionStatus:
    state.billingAndSubscription.handleLeadFinderChurnkeySubscriptionRequest
      .status,
  sendGetHandleInboxAnalyzerChurnkeySubscriptionError:
    state.billingAndSubscription.handleInboxAnalyzerChurnkeySubscriptionRequest
      .error,
  sendGetHandleInboxAnalyzerChurnkeySubscriptionStatus:
    state.billingAndSubscription.handleInboxAnalyzerChurnkeySubscriptionRequest
      .status,
  planTransitionDetails: state.home.subscription?.planTransitionDetails,
  leadFinderPlanTransitionDetails:
    state.home.leadFinderSubscription?.planTransitionDetails,
  churnkeyHash: state.home.churnkeyHash,
  leadFinderChurnkeyHash: state.home.leadFinderChurnkeyHash,
  inboxAnalyzerChurnkeyHash: state.home.inboxAnalyzerChurnkeyHash,
  subscriptionPlanStatus: state.home.subscription?.status,
  leadFinderSubscriptionPlanStatus: state.home?.leadFinderSubscription?.status,
  inboxAnalyzerSubscriptionPlanStatus:
    state.home?.inboxAnalyzerSubscription?.status,
  pauseEndsAt: state.home.subscription?.pauseEndsAt,
  leadFinderPauseEndsAt: state.home.leadFinderSubscription?.pauseEndsAt,
  inboxAnalzerPauseEndsAt: state.home.inboxAnalyzerSubscription?.pauseEndsAt,
  pausedAt: state.home.subscription?.pausedAt,
  leadFinderpausedAt: state.home.leadFinderSubscription?.pausedAt,
  inboxAnalyzerPausedAt: state.home.inboxAnalyzerSubscription?.pausedAt,
  ltdExpiryDate: state.home.agencyConfig?.ltdExpiryDate,
  planCode: state.home?.subscription?.planCode,
  leadFinderPlanCode: state.home?.leadFinderSubscription?.planCode,
  inboxAnalyzerPlanCode: state.home?.inboxAnalyzerSubscription?.planCode,
  planType: state.home?.subscription?.planType,
  leadFinderPlanType: state.home?.leadFinderSubscription?.planType,
  inboxAnalyzerPlanType: state.home?.inboxAnalyzerSubscription?.planType,
  currentPlanName: state.home?.subscription?.planName,
  purchaseHistory: state.billingAndSubscription.purchaseHistory,
  getPurchaseHistoryRequestStatus:
    state.billingAndSubscription.getPurchaseHistoryRequest.status,
  hasDomains: state.home.hasDomains,
  exportCreditHistoryRequestStatus:
    state.billingAndSubscription.exportCreditHistoryRequest.status,
  exportCreditHistoryRequestMessage:
    state.billingAndSubscription.exportCreditHistoryRequest.message,
  timeZone: state?.myProfile?.myProfile?.timeZone,

  calculateAiCreditsPricingsRequestStatus:
    state.billingAndSubscription.calculateAiCreditsPricingsRequest.status,
  calculateAiCreditsPricingsResponse:
    state.billingAndSubscription.calculateAiCreditsPricingsResponse,
  purchaseAiCreditsRequestStatus:
    state.billingAndSubscription.purchaseAiCreditsRequest.status,
  featureUsages: state.home.featureUsages,
  getPostLoadMetaRequestStatus: state.home.getPostLoadMetaRequest.status,
  aiCreditHistoryRequestStatus:
    state.billingAndSubscription.aiCreditHistoryRequest.status,
  aiCreditHistoryRequestMessage:
    state.billingAndSubscription.aiCreditHistoryRequest.message,
  isProspectEnrichmentEnabledMeta: state?.home?.isProspectEnrichmentEnabled,
  isOldAgencyUser: state?.home?.isAgencyUser,
  isDialerFeatureEnabled: state?.home?.isDialerFeatureEnabled,
  // Credits transaction polling
  getCreditsTransactionStatusRequestStatus:
    state.billingAndSubscription.getCreditsTransactionStatusRequest.status,
  getCreditsTransactionStatusResponse:
    state.billingAndSubscription.getCreditsTransactionStatusResponse,

  paymentProvider: state.home?.paymentProvider,
});

const mapDispatchToProps = {
  sendGetAccountSubscriptionRequest: () => getAccountSubscriptionRequest(),
  sendGetAccountSubscriptionPlanRequest: (id: string) =>
    getAccountSubscriptionPlanRequest(id),
  sendGetInboxAnalyzerSubscriptionPlanRequest: (id: string) =>
    getInboxAnalyzerSubscriptionPlanRequest(id),
  sendGetLeadFinderSubscriptionRequest: () =>
    getLeadFinderSubscriptionRequest(),
  sendGetInboxAnalyzerSubscriptionRequest: () =>
    getInboxAnalyzerSubscriptionRequest(),
  sendGetPlansRequest: () => getPlansRequest(),
  sendGetInvoiceURLRequest: (customerId: string) =>
    getInvoiceURLRequest({ customerId }),
  sendGetInboxAnalyzerInvoiceURLRequest: (customerId: string) =>
    getInboxAnalyzerInvoiceURLRequest({ customerId }),
  sendPurchaseSubscriptionRequest: (payload: PurchaseSubscriptionRequest) =>
    purchaseSubscriptionRequest(payload),
  resetSubscription: () => resetSubscription(),
  resetPurchaseEmailVerificationCreditsResponse: () =>
    resetPurchaseEmailVerificationCreditsResponse(),
  resetReactivateSubscriptionResponse: () =>
    resetReactivateSubscriptionResponse(),
  resetReactivateLeadFinderSubscriptionResponse: () =>
    resetReactivateLeadFinderSubscriptionResponse(),
  resetReactivateInboxAnalyzerSubscriptionResponse: () =>
    resetReactivateInboxAnalyzerSubscriptionResponse(),
  resetResumeSubscriptionResponse: () => resetResumeSubscriptionResponse(),
  resetResumeLeadFinderSubscriptionResponse: () =>
    resetResumeLeadFinderSubscriptionResponse(),
  resetResumeInboxAnalyzerSubscriptionResponse: () =>
    resetResumeInboxAnalyzerSubscriptionResponse(),
  resetHandleSubscriptionResponse: () => resetHandleSubscriptionResponse(),
  resetHandleLeadFinderSubscriptionChurnkeyResponse: () =>
    resetHandleLeadFinderSubscriptionChurnkeyResponse(),
  resetHandleInboxAnalyzerSubscriptionChurnkeyResponse: () =>
    resetHandleInboxAnalyzerSubscriptionChurnkeyResponse(),
  sendGetUserSettingsRequest: () => getUserSettingsRequest(),
  sendGetUserSubscriptionMetadataRequest: () =>
    getUserSubscriptionMetadataRequest(),
  sendGetConnectedUsersAndEmailAccountsRequest: () =>
    getConnectedUsersAndEmailAccountsRequest(),
  sendApplyCouponCodeRequest: (payload: ApplyCouponCodeRequest) =>
    applyCouponCodeRequest(payload),
  deleteAppliedCouponCode: () => deleteAppliedCouponCode(),
  sendGetEmailVerificationCreditsRequest: () =>
    getEmailVerificationCreditsRequest(),
  sendGetEmailVerificationPlansRequest: () => getEmailVerificationPlanRequest(),
  sendPurchaseEmailVerificationCreditsRequest: (
    payload: PurchaseEmailVerificationCreditsRequest,
  ) => purchaseEmailVerificationCreditsRequest(payload),
  sendModifySubscriptionRequest: (payload: ModifySubscriptionRequest) =>
    modifySubscriptionRequest(payload),
  sendInboxAnalyzerModifySubscriptionRequest: (
    payload: ModifySubscriptionRequest,
  ) => modifyInboxAnalyzerSubscriptionRequest(payload),
  sendPurchaseModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseModifySubscriptionRequest(payload),
  sendPurchaseLeadFinderModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseLeadFinderModifySubscriptionRequest(payload),
  sendReactivateSubscriptionRequest: (
    payload: ReactivateResumeSubscriptionRequest,
  ) => reactivateSubscriptionRequest(payload),
  sendReactivateLeadFinderSubscriptionRequest: (
    payload: ReactivateResumeSubscriptionRequest,
  ) => reactivateLeadFinderSubscriptionRequest(payload),
  sendReactivateInboxAnalyzerSubscriptionRequest: (
    payload: ReactivateResumeSubscriptionRequest,
  ) => reactivateInboxAnalyzerSubscriptionRequest(payload),
  sendResumeSubscriptionRequest: (
    payload: ReactivateResumeSubscriptionRequest,
  ) => resumeSubscriptionRequest(payload),
  sendResumeInboxAnalyzerSubscriptionRequest: (
    payload: ReactivateResumeSubscriptionRequest,
  ) => resumeInboxAnalyzerSubscriptionRequest(payload),
  sendResumeLeadFinderSubscriptionRequest: (
    payload: ReactivateResumeSubscriptionRequest,
  ) => resumeLeadFinderSubscriptionRequest(payload),
  sendHandleSubscriptionRequest: (payload: HandleSubscriptionRequest) =>
    handleSubscriptionRequest(payload),
  sendHandleLeadFinderChurnkeySubscriptionRequest: (
    payload: HandleSubscriptionRequest,
  ) => handleLeadFinderChurnkeySubscriptionRequest(payload),
  sendHandleInboxAnalyzerChurnkeySubscriptionRequest: (
    payload: HandleSubscriptionRequest,
  ) => handleInboxAnalyzerChurnkeySubscriptionRequest(payload),
  resetModifySubscriptionResponse: () => resetModifySubscriptionResponse(),
  resetInvoice: () => resetInvoice(),
  resetInboxAnalyzerInvoice: () => resetInboxAnalyzerInvoice(),
  hideLoading: () => hideLoading(),
  showLoading: () => showLoading(),
  sendPurchaseHistoryRequest: () => getPurchaseHistoryRequest(),
  sendExportCreditHistoryRequest: (payload: ExportCreditHistoryPayload) =>
    exportCreditHistoryRequest(payload),
  resetExportCreditHistoryRequest: () => resetExportCreditHistoryRequest(),
  resetPurchaseLeadFinderOneTimePlan: () =>
    resetPurchaseLeadFinderOneTimePlan(),
  sendAiCreditHistoryRequest: (payload: ExportCreditHistoryPayload) =>
    aiCreditHistoryRequest(payload),
  resetAiCreditHistoryRequest: () => resetAiCreditHistoryRequest(),

  sendCalculateAiCreditsPricingsRequest: (
    payload: CalculateAiCreditsPricingsRequest,
  ) => calculateAiCreditsPricingsRequest(payload),
  sendGetPostLoadMetaRequest: () => getPostLoadMetaRequest(),
  // Credits transaction polling
  sendGetCreditsTransactionStatusRequest: (
    payload: CreditsTransactionStatusRequest,
  ) => getCreditsTransactionStatusRequest(payload),
  resetGetCreditsTransactionStatusRequest: () =>
    resetGetCreditsTransactionStatusRequest(),
  resetPurchaseCreditsRequest: () => resetPurchaseCreditsRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export type LocationStateType = {
  isModifySubscription: boolean;
};

export default connector(BillingSubscription);
